// Category counts are per I/O type and per device, never DI + DO totals.
export function matchesModel(model, filters) {
  const circuits =
    filters.type === "all"
      ? Math.max(model.digital, model.analog)
      : model[filters.type];
  return (
    circuits > 0 &&
    circuits >= filters.minimum &&
    (!filters.hardware.length || filters.hardware.includes(model.hardware)) &&
    (!filters.communications.length ||
      filters.communications.some((value) =>
        model.communications.includes(value),
      ))
  );
}

function readFilters(form) {
  const data = new FormData(form);
  return {
    type: data.get("type"),
    hardware: data.getAll("hardware"),
    communications: data.getAll("communication"),
    minimum: Number(data.get("minimum")),
  };
}

function readRow(row) {
  const variants = JSON.parse(row.dataset.variants);
  return {
    row,
    variants,
    digital: Number(row.dataset.digital),
    analog: Number(row.dataset.analog),
    hardware: row.dataset.hardware,
    communications: [
      ...new Set(variants.flatMap((variant) => variant.communications)),
    ],
  };
}

function updateVariantLink(model, filters) {
  const variant = model.variants.find(
    (item) =>
      !filters.communications.length ||
      item.communications.some((value) =>
        filters.communications.includes(value),
      ),
  );
  const link = model.row.querySelector("[data-product-link]");
  link.href = `${model.row.dataset.url}?variant=${variant.id}`;
}

if (
  typeof window !== "undefined" &&
  !customElements.get("yengear-io-selector")
) {
  customElements.define(
    "yengear-io-selector",
    class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.form = this.querySelector("form");
        this.models = [...this.querySelectorAll("[data-io-model]")].map(
          readRow,
        );
        this.page = 0;
        const options = { signal: this.controller.signal };
        this.form.addEventListener(
          "change",
          () => {
            this.page = 0;
            this.render();
          },
          options,
        );
        this.form.addEventListener(
          "reset",
          () => {
            queueMicrotask(() => {
              this.page = 0;
              this.render();
            });
          },
          options,
        );
        this.querySelectorAll("[data-clear]").forEach((button) =>
          button.addEventListener("click", () => this.form.reset(), options),
        );
        this.querySelector("[data-previous]").addEventListener(
          "click",
          () => this.changePage(-1),
          options,
        );
        this.querySelector("[data-next]").addEventListener(
          "click",
          () => this.changePage(1),
          options,
        );
        this.form.hidden = false;
        this.querySelector("[data-pagination]").hidden = false;
        this.render();
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
      changePage(delta) {
        this.page += delta;
        this.render();
        this.querySelector("[data-result-heading]").focus({
          preventScroll: true,
        });
        this.querySelector("[data-result-heading]").scrollIntoView({
          block: "nearest",
        });
      }
      render() {
        const filters = readFilters(this.form);
        const matches = this.models.filter((model) =>
          matchesModel(model, filters),
        );
        const pages = Math.max(1, Math.ceil(matches.length / 4));
        this.page = Math.min(this.page, pages - 1);
        const visible = matches.slice(this.page * 4, this.page * 4 + 4);
        this.models.forEach((model) => {
          model.row.hidden = !visible.includes(model);
        });
        visible.forEach((model) => updateVariantLink(model, filters));
        this.querySelector("[data-result-count]").textContent =
          `${matches.length} matching models`;
        this.querySelector("[data-empty]").hidden = matches.length !== 0;
        this.querySelector("[data-page-label]").textContent =
          `Page ${this.page + 1} of ${pages}`;
        this.querySelector("[data-pagination]").hidden = matches.length === 0;
        this.querySelector("[data-previous]").disabled = this.page === 0;
        this.querySelector("[data-next]").disabled = this.page === pages - 1;
      }
    },
  );
}
